import React from 'react';
import MenuItem from './MenuItem';
import NewId from '../../../utils/NewId';

export default class NavigationMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {items: []};
    }

    componentWillMount() {
        this.buildItems(this.props);
    }

    componentWillReceiveProps(props) {
        this.buildItems(props);
    }

    buildItems(props) {
        let items = props.items.map((item) => {
            return Object.assign({}, item, {key: NewId('menu-item')});
        });

        this.setState({items});
    }

    render() {
        return <ul className={this.props.className ? this.props.className : ""}>
            {this.state.items.map((item) => <MenuItem {...item} />)}
            {this.props.children}
        </ul>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Navigation/NavigationMenu.js